import React, { useEffect, useRef, useState } from 'react';
import { useSelector, connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { getLanguage, getQueryString } from 'utils/params';
import { postContactUsRequest, getTypesDropdown } from '../servicedOffice.api';
import { Modal } from 'react-bootstrap';
import { Select } from 'components';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { Close } from '../../../assets/images/web-isn';
import { toast } from 'react-toastify';
import IconContact from 'assets/images/Group2676.svg';

const ServicedOfficeContactUs = props => {
  const { t } = useTranslation();
  const location = useLocation();
  const language = getLanguage(location);
  const [isShowSubmit, setIsShowSubmit] = useState(false);
  const [responseForm, setResponseForm] = useState(null);
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef();
  const [type, setType] = useState(0);
  var [servicedType] = useState([
    {
      id: 0,
      name: `${t("servicedOffice.other")}`,
      content: null,
      imageUrl: null,
      imageUrl2: null,
      imageUrl3: null,
      price: null,
      title: null,
    }
  ])
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [inputData, setInputData] = useState({
    email: '',
    phone: '',
    fullName: '',
    companyName: '',
    description: '',
    typeId: ''
  });
  const [errors, setErrors] = useState({});

  const userInfo = useSelector(state => state.loginData.userInfo);

  useEffect(() => {

    getTypesDropdown(getQueryString({ language })).then(res => {
      if (res) {
        servicedType.push(...res);
      }
    })

    const authUserData = JSON.parse(localStorage.getItem('authUserData'));
    let user = userInfo ?? authUserData?.userInfo;
    if (user) {
      setInputData({
        ...inputData,
        fullName: user?.fullName ? user.fullName : '',
        email: user?.email ?? user?.userEmail ?? '',
        phone: user?.phoneNumber ?? user?.userPhone ?? '',
        companyName: user?.companyName ?? '',
      });
    } else {
      setInputData({
        email: '',
        phone: '',
        fullName: '',
        companyName: '',
        description: '',
        typeId: ''
      });
    }
    setResponseForm(false);
    setErrors(null);
    // eslint-disable-next-line
  }, [userInfo]);

  const handleValueSelect = (e) => {
    setType(e)
  }

  const handleChangeInput = e => {
    if (responseForm) {
      setResponseForm(false);
    }
    let { name } = e.target;
    let { value } = e.target;
    if (name === 'phone') {
      value = value.replace(/[^\d/+-]/g, '');
      value = value.replace(/^([+0-9]{3})([0-9]{3})([0-9]{4})$/, '$1$2$3');
    }
    setInputData({
      ...inputData,
      [name]: value,
    });
    if (name === 'fullName') {
      if (value.trim().length === 0) {
        setErrors({
          ...errors,
          fullName: t('about_isn.contact_us.err_fullname'),
        });
      } else {
        resetError(name);
      }
    }
    if (name === 'email') {
      if (value.trim().length === 0) {
        setErrors({
          ...errors,
          email: t('about_isn.contact_us.err_email'),
        });
      } else {
        resetError(name);
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
          setErrors({
            ...errors,
            email: t('about_isn.contact_us.err_email_format'),
          });
        }
      }
    }
    if (name === 'phone') {
      if (value.trim().length === 0) {
        setErrors({
          ...errors,
          phone: t('about_isn.contact_us.err_phone_number'),
        });
      } else {
        resetError(name);
        if (value.length < 7 || value.length > 15) {
          setErrors({
            ...errors,
            phone: t('about_isn.contact_us.err_phone_format'),
          });
        }
      }
    }
  };

  const checkValidate = () => {
    let error = null;
    if (inputData.fullName.trim().length === 0) {
      error = { ...error, fullName: t('about_isn.contact_us.err_fullname') };
    }
    if (inputData.email.trim().length === 0) {
      error = { ...error, email: t('about_isn.contact_us.err_email') };
    } else {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputData.email)) {
        error = { ...error, email: t('about_isn.contact_us.err_email_format') };
      }
    }
    if (inputData.phone.trim().length === 0) {
      error = { ...error, phone: t('about_isn.contact_us.err_phone_number') };
    } else {
      if (inputData.phone.length < 7 || inputData.phone.length > 15) {
        error = { ...error, phone: t('about_isn.contact_us.err_phone_format') };
      }
    }
    setErrors(error);
    return error == null;
  };

  const resetError = name => {
    let errorNew = errors;
    if (errors && errors[name]) {
      delete errorNew[name];
    }
    setErrors({ ...errorNew });
  };

  const resetForm = () => {
    const authUserData = JSON.parse(localStorage.getItem('authUserData'));
    let user = userInfo ?? authUserData?.userInfo;
    setInputData({
      email: user?.email ?? user?.userEmail ?? '',
      phone: user?.phoneNumber ?? user?.userPhone ?? '',
      companyName: user?.companyName ?? '',
      fullName: user?.fullName ? user.fullName : '',
      description: '',
      typeId: ''
    });
    setIsShowSubmit(false);
    recaptchaRef.current.reset();
  };

  const messageSuccess = (
    <>
      <div>{t('about_isn.contact_us.message_send_success')}</div>
    </>
  );

  const onSubmit = values => {
    if (checkValidate()) {
      let FormData = require('form-data');
      let data = new FormData();

      //data.append('Language', language);
      data.append('FullName', values.fullName);
      data.append('Email', values.email);
      data.append('PhoneNumber', values.phone);
      data.append('CompanyName', values.companyName);
      data.append('TypeId', type);
      data.append('Description', values.description);
      data.append('CaptchaToken', captchaToken);
      showLoader();
      postContactUsRequest(data).then(res => {
        if (res) {
          setResponseForm(res.status);
          resetForm();
          toast.success(messageSuccess, { autoClose: 5000 });
        }
        hideLoader();
      });
    }
  };


  const checkCaptcha = value => {
    if (responseForm) {
      setResponseForm(false);
    }
    if (value) {
      setCaptchaToken(value);
      setIsShowSubmit(true);
    }
  };

  const handleCloseModal = () => {
    props.closeLogin();
  };

  return (
    <>
      <Modal centered dialogClassName={"contact-us-modal"} show={props.showLogin} backdrop="static" onHide={handleCloseModal}>
        <div className="close-btn" onClick={handleCloseModal}>
          <img src={Close} alt="close-icon" />
        </div>
        <div className="container">
          <div className="contact-form">
            <div className="contact-form-head">
              <div className="row">
                <div className="col-9">
                  <div
                    className="contact-form-title jp-bold-600"
                    dangerouslySetInnerHTML={{
                      __html: t('about_isn.contact_us.title_contact'),
                    }}
                  ></div>
                </div>
                <div className="col-3 text-right">
                  <img src={IconContact} alt="" />
                  {/* <LazyLoadImage src={IconContact} alt="" effect="blur" /> */}
                </div>
                <div className="col-9 jp-font-sawarabi-gothic">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: t('about_isn.contact_us.content_thank_you'),
                    }}
                  ></div>
                  <div
                    className="contact-content"
                    dangerouslySetInnerHTML={{
                      __html: t('about_isn.contact_us.our_person'),
                    }}
                  ></div>
                  <hr className="contact-form-line" />
                </div>
              </div>
            </div>
            <form
              id="contact"
              onSubmit={e => {
                e.preventDefault();
              }}
            >
              <div className="form-group">
                <label>
                  {t('about_isn.contact_us.full_name')} <span className="link-red-bold ">*</span>
                </label>
                <input
                  type="text"
                  className={'form-control' + (errors?.fullName ? ' is-error' : '')}
                  name="fullName"
                  onChange={e => {
                    handleChangeInput(e);
                  }}
                  value={inputData.fullName}
                  maxLength={255}
                />
                <small className="error">{errors?.fullName && errors.fullName}</small>
              </div>

              <div className="form-group">
                <label>
                  {t('about_isn.contact_us.email')} <span className="link-red-bold ">*</span>
                </label>
                <input
                  type="text"
                  className={'form-control' + (errors?.email ? ' is-error' : '')}
                  name="email"
                  value={inputData.email}
                  onChange={handleChangeInput}
                  maxLength={255}
                />
                <small className="error">{errors?.email && errors?.email}</small>
              </div>

              <div className="form-group">
                <label>
                  {t('about_isn.contact_us.phone_number')} <span className="link-red-bold ">*</span>
                </label>
                <input
                  type="text"
                  className={'form-control' + (errors?.phone ? ' is-error' : '')}
                  name="phone"
                  value={inputData.phone}
                  onChange={handleChangeInput}
                  maxLength={255}
                />
                <small className="error">{errors?.phone && errors?.phone}</small>
              </div>

              <div className="form-group">
                <label>{t('about_isn.contact_us.company_name')}</label>
                <input
                  type="text"
                  className="form-control"
                  name="companyName"
                  value={inputData.companyName}
                  onChange={handleChangeInput}
                  maxLength={255}
                />
              </div>
              <div className="form-group">
                <label>
                  {t('servicedOffice.interest')}
                </label>
                <Select
                  options={servicedType.map(item => ({ value: item.id, label: item.name }))}
                  class_name="form-control font-noto-sans-jp"
                  name="location"
                  onChange={(e) => handleValueSelect(e)}
                  defaultValue={type}
                />
              </div>

              <div className="form-group">
                <label>
                  {t('servicedOffice.message')}
                </label>
                <textarea
                  className={'form-control area-requirement' + (errors?.description ? ' is-error' : '')}
                  name="description"
                  onChange={handleChangeInput}
                  value={inputData.description}
                ></textarea>
              </div>
              <div className="mb-3">
                {language === 'en' ?
                  <label>
                    By clicking Submit, you agree to our <a className="link-yellow-bold" href={`/${language}/policy/privacy-policy`}>Privacy policy</a>
                  </label> : ''}
                {language === 'vi' ?
                  <label>
                    Bằng việc nhấn Gửi, bạn đồng ý với <a className="link-yellow-bold" href={`/${language}/policy/privacy-policy`}>Chính sách bảo mật</a> của chúng tôi
                  </label> : ''}
                {language === 'jp' ?
                  <label>
                    [送信]をクリックすることにより、<a className="link-yellow-bold" href={`/${language}/policy/privacy-policy`}>プライバシーポリシー</a>に同意したとみなされます。
                  </label> : ''}
              </div>

              <div className="row">
                <div className="col-12 pb-2">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={process.env.REACT_APP_KEY_CAPTCHA}
                    onChange={checkCaptcha}
                    onExpired={() => {
                      setIsShowSubmit(false);
                    }}
                    hl={`${language === 'vi' ? 'vi' : language === 'en' ? 'en' : 'ja'}`}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12 button-handle d-flex justify-content-center">
                  <button
                    type="submit"
                    id="send"
                    className="btn-booknow"
                    disabled={!isShowSubmit}
                    onClick={() => {
                      onSubmit(inputData);
                    }}
                  >
                    {t('detailApartment.submit')}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      {loader}
    </>
  );
}
const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(ServicedOfficeContactUs);
